<template>
	<div class="mainMap">
		<div class="maskTitle">
			<span>事故发生地点</span>
			<span @click="close"><i class="el-icon-close"></i></span>
		</div>
		<div class="block" id="container"></div>
	</div>
</template>

<script>
import { TMap } from '../../../../static/js/tencertMap.js'
export default {
    props: ['lng', 'lat', 'time'],
    name: 'mapMask',
    data() {
        return {
            conter: null, //地图中心点
            map: null, // 地图
            markerLayer: null, //MultiMarker
        }
    },
    mounted() {
        this.initMethod();
    },
    methods: {
        close() {
            this.$emit('hideMap')
        },
        initMethod() {
          	TMap('OV6BZ-MN7CD-EWA4C-PHQRX-XGWQZ-HSFCG').then(qq => {
				var time = this.AppUtils.formatDateToSecond(this.time)
				let lng = this.lng;
				let lat = this.lat;
				// 第一步，初始化地图
				var center = new qq.maps.LatLng(lat, lng);
				var map = new qq.maps.Map(document.getElementById('container'), {
					center: center,
					zoom: 13,
				});
				//第二步，初始marker
				var marker = new qq.maps.Marker({
					position: center,
					map: map,
				});
				var anchor = new qq.maps.Point(10, 37),
					size = new qq.maps.Size(42, 68),
					origin = new qq.maps.Point(0, 0),
					markerIcon = new qq.maps.MarkerImage(
						"https://3gimg.qq.com/lightmap/api_v2/2/4/99/theme/default/imgs/marker.png",
						size,
						origin,
						anchor
					);
				marker.setIcon(markerIcon);
				//第三步，初始化infoWindow
				var infoWindow = new qq.maps.InfoWindow({
					map: map,
					position: new qq.maps.LatLng(lat, lng),
					offset: new qq.maps.Size(42, 68)
				})
				infoWindow.close();
				qq.maps.event.addListener(marker, 'click', function () {
					infoWindow.open()
					infoWindow.setPosition(marker.getPosition());

					// infoWindow.setContent(`<div>第一个记录点</div>到达时间：${time}</div>`);
				})
            })
        },

    }
}
</script>

<style lang="scss" scoped>
.mainMap {
    /*width: 100vw;*/
    /*height: 100vh;*/
    display: flex;
    background: #fff;
    flex-direction: row;
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    z-index: 101;
    flex-direction: column;
    box-sizing: border-box;

    .maskTitle {
        padding: 10px;
        box-sizing: border-box;
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: calc(100%);
        box-sizing: border-box;
        background: #ccc;
        z-index: 102;
    }
}
</style>



// WEBPACK FOOTER //
// mapMask.vue?44de0df6